module.exports = __webpack_public_path__ + "static/media/snapFood.f04b1af5.jpg";